"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Erc1155ContractDeployButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const wagmi_1 = require("wagmi");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const provider_user_1 = require("@dzambalaorg/provider-user");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const deployERC1155Token_json_1 = __importDefault(require("@framework/abis/json/ERC1155FactoryFacet/deployERC1155Token.json"));
const dialogs_1 = require("../../../../dialogs");
const validation_1 = require("./dialog/validation");
const Erc1155ContractDeployButton = (props) => {
    const { className, disabled, variant = styled_1.ListActionVariant.button } = props;
    const { profile } = (0, provider_user_1.useUser)();
    const { chainId } = (0, wagmi_1.useAccount)();
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    // TOKEN URI WITH CHAIN_ID
    const tokenURI = `${process.env.JSON_URL}/metadata/${chainId ? chainId.toString() : "0"}`;
    const initialValues = {
        contractTemplate: types_1.Erc1155ContractTemplates.SIMPLE,
        baseTokenURI: tokenURI,
        royalty: 0,
    };
    const { handleDeployConfirm } = (0, react_hooks_eth_1.useDeploy)(async (values, sign, systemContract) => {
        const nonce = sign.nonce;
        return writeContractAsync({
            address: systemContract.address,
            abi: deployERC1155Token_json_1.default,
            functionName: "deployERC1155Token",
            args: [
                {
                    nonce,
                    bytecode: sign.bytecode,
                    externalId: BigInt(profile.id),
                },
                {
                    contractTemplate: Object.values(types_1.Erc1155ContractTemplates).indexOf(values.contractTemplate).toString(),
                    baseTokenURI: values.baseTokenURI,
                    royalty: BigInt(values.royalty),
                },
                sign.signature,
            ],
        });
    });
    const onDeployConfirm = ({ data, form }) => {
        return handleDeployConfirm({
            url: "/contract-manager/erc1155",
            method: "POST",
            data,
        }, form);
    };
    const handleDeploy = () => {
        openDialog(dialogs_1.GlobalDialogKeys.ERC1155_CONTRACT_DEPLOY, initialValues, {
            initialValues,
            validationSchema: validation_1.erc1155DeployValidationSchema,
            message: "dialogs.deploy",
            testId: "Erc1155ContractDeployForm",
            onExternalConfirm: onDeployConfirm,
        });
    };
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleDeploy, icon: icons_material_1.Add, message: "form.buttons.deploy", className: className, dataTestId: "Erc1155ContractDeployButton", disabled: disabled, variant: variant }));
};
exports.Erc1155ContractDeployButton = Erc1155ContractDeployButton;
//# sourceMappingURL=index.js.map